import API from "../utilities/LocalApiProxy";

export function getAiSessions(matterIds) {
	return API.post("/ai/sessions", { body: { matterIds } }).then(
		(res) => res.mysql
	);
}

export function getAiSession(sessionId, matterID) {
	return API.get("/ai/session", {
		queryParams: { sessionId, matterID },
	}).then((res) => res.mysql);
}

export function sendAiChatMessage({
	matterIds,
	sessionId,
	message,
	addedContext,
}) {
	return API.post("/ai/chat", {
		body: { matterIds, sessionId, message, addedContext },
	}).then((res) => res.mysql);
}

export function updateAiSessionTitle({ sessionId, title }) {
	return API.put("/ai/session", {
		body: { sessionId, title },
	}).then((res) => res.mysql);
}

export function updateAiSessionContext({ sessionId, addedContext }) {
	return API.put("/ai/session", {
		body: { sessionId, addedContext },
	}).then((res) => res.mysql);
}

export function deleteAiSession(sessionId) {
	return API.post("/ai/session/delete", {
		body: { sessionId },
	}).then((res) => res.mysql);
}

export function pollAiChatMessage({ sessionId, afterMessageId }) {
	return API.get(
		"/ai/chat/poll",
		{ queryParams: { sessionId, afterMessageId } },
		// MatterAiChat keeps polling through rate limits
		{ suppressRateLimitSnackbar: true }
	).then((res) => res.mysql);
}

export function cancelAiChatMessage(sessionId) {
	return API.post("/ai/chat/cancel", {
		body: { sessionId },
	}).then((res) => res.mysql);
}
